import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";
import AuthGate from "./AuthGate";
import ErrorBoundary from "./components/ErrorBoundary";

// The gateway admin app is always namespaced under /gateway in both prod and
// dev. Rewrite the URL to add the prefix when missing so visiting
// `localhost:3001/` doesn't blank the app out.
const ROUTER_BASENAME = "/gateway";
const ensurePathHasBasename = () => {
  if (typeof window === "undefined") return;
  const path = window.location.pathname || "";
  if (path === ROUTER_BASENAME || path.startsWith(`${ROUTER_BASENAME}/`)) return;
  const next =
    path === "/" || path === ""
      ? `${ROUTER_BASENAME}/`
      : `${ROUTER_BASENAME}${path}`;
  window.history.replaceState(
    null,
    "",
    `${next}${window.location.search}${window.location.hash}`
  );
};

ensurePathHasBasename();

const root = ReactDOM.createRoot(document.getElementById("root"));
const ROUTER_FUTURE = { v7_relativeSplatPath: true };
root.render(
  <ErrorBoundary>
    <BrowserRouter basename={ROUTER_BASENAME} future={ROUTER_FUTURE}>
      <AuthGate>
        <App />
      </AuthGate>
    </BrowserRouter>
  </ErrorBoundary>
);
